import { useState, memo } from "react";
import "./QuotationRoomBody.scss";
import PropTypes from "prop-types";
import MoreDetails from "app/pages/.shared/MoreDetails.jsx";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import { FormattedMessage } from "react-intl";
import QuotationRoomDetailsModal from "./QuotationRoomDetailsModal";
import QuotationRoomBodyItem from "./QuotationRoomBodyItem";
import _ from "lodash";

const QuotationRoomBody = ({ rooms }) => {
	const [showRoomDetails, setShowRoomDetails] = useState(true);
	const [isRoomDetailsModalOpen, setIsRoomDetailsModalOpen] = useState(false);

	const uniqueRooms = _.uniqBy(rooms, "id");
	const hasMultipleRooms = uniqueRooms?.length > 1;

	if (!uniqueRooms || uniqueRooms.length === 0) {
		return null;
	}

	const toggleOpenModal = () => {
		setIsRoomDetailsModalOpen(prev => !prev);
	};

	return (
		<div className="quotation-room-body">
			<MoreDetails expanded={showRoomDetails}>
				{uniqueRooms.map((room, index) => (
					<QuotationRoomBodyItem
						key={room.id + index}
						room={room}
						showRoomTitle={hasMultipleRooms}
						toggleOpenModal={toggleOpenModal}
					/>
				))}
			</MoreDetails>

			<Button
				onClick={() => setShowRoomDetails(!showRoomDetails)}
				variant={BUTTON_VARIANTS.BORDERLESS}
				className="quotation-room-body__details-button"
				label={
					<FormattedMessage
						id={
							showRoomDetails
								? `product.page.less.details`
								: `product.page.more.details`
						}
					/>
				}
			/>

			<QuotationRoomDetailsModal
				isOpen={isRoomDetailsModalOpen}
				onClose={toggleOpenModal}
				rooms={rooms}
			/>
		</div>
	);
};

QuotationRoomBody.propTypes = {
	rooms: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string,
			photos: PropTypes.arrayOf(
				PropTypes.shape({
					url: PropTypes.string,
					thumbnail: PropTypes.string,
				})
			),
			description: PropTypes.string,
			amenities: PropTypes.arrayOf(PropTypes.string),
			occupancy: PropTypes.shape({
				adults: PropTypes.number,
				children: PropTypes.number,
				babies: PropTypes.number,
			}),
		})
	),
};

export default memo(QuotationRoomBody);
